import React from "react";
import { Modal, Button } from "react-bootstrap";
import QuestionPopupForm from "../Question/QuestionForm";
import AnswerForm from "../Answer/AnswerForm";

class AskQuestion extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      canAnsSubmit: false
    }
  }

  render() {
    const { canAnsSubmit, canSubmit } = this.state;
    const { show, close, _onFormValid, _onAnsFormValid, setQuestionFormRef, setAnswerFormRef, onSubmit } = this.props;

    return (
      <Modal className="lg-modal" show={show} onHide={close}>
        <Modal.Header closeButton>
          <Modal.Title>Ask question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <QuestionPopupForm isValid={_onFormValid} ref={ref => setQuestionFormRef(ref)} />
          <AnswerForm isValid={_onAnsFormValid} ref={ref => setAnswerFormRef(ref)} />
        </Modal.Body>
        <Modal.Footer>
          <div>
            <Button
              bsStyle="primary"
              disabled={canSubmit && canAnsSubmit}
              onClick={e => onSubmit(e)}
            >
              Submit
            </Button>
            <Button
              className="m-l-5p"
              type="submit"
              bsStyle="default"
              onClick={() => close()}
            >
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AskQuestion;
